export const locale = {
  lang: 'zh1',
  data: {
    'LANDINFOCUS': {
      'ENCUESTAS':{
        'TITULO':'這是重點領域的過程',
        'NO-ENCU':'您當前沒有分配的調查流程',
        'ENC-AUTO':'授權調查',
        'ENC-CORRECI':'該調查已發送給更正',
        'MODAL_NO_COLAB_EMPRE':'您尚未上傳您的貢獻者庫，確定要繼續嗎？',

      },
      'STATUS-ENCUESTA':{
        '1':'處理中',
        '2':'評估',
        '3':'授權',
        '5':'正確',

      },
      'LISTA': {
        'TAB': '參賽者名單',
        'BUSCAR': {
          'INFO': '您可以通過輸入以下名稱從列表中搜索一個或多個參與者',
          'PLACEHOLDER': '尋找參加者'
        },
        'AGREGAR': {
          'BOTON': '添加參與者'
        },
        'TABLA': {
          'COLUMNAS': {
            'NOMBRE': '全名',
            'EMAIL': '電子郵件',
            'ACCIONES': '可用操作'
          }
        },
        'TOOLTIPS': {
          'AGREGAR': '將參與者添加到列表中',
          'EDITAR': '編輯此參與者數據'
        }
      },
      'MODALES':{
        'CREARENC': '輸入調查名稱',
        'CORRECTO': '已正确添加',
        'COMDELETE': '正確刪除',
        'DELETE': '你真的想消除',
        'RSPSI':'是',
        'RSPNO':'沒有',
        'RSPOK':'好',
        'RSPACEPTAR':'接受',
        'CARGANDOLISTA': '正在獲取參與者列表，請稍等'

      },
      'WIZARD':{
        'CARGANDOF': '加載獲取的產品',
        'SINPRODS': '您尚未購買此產品',
        'CREARENC': '創建調查',
        'DONE': '申請年份 ',
        'TITULO': '歡迎來到重點領域',
        'TFOCUS': '調查到重點區域',
        'DELETE': '刪除',
        'EDIT': '編輯',
        'VERIPRE':'檢查問題',
        'AVANCE':'預先',
        'TITUVERI':'驗證問題',
        'TITUTABTEM':'有關模板的問題',
        'TITUTABADI':'個性化問題',
        'TITUTAUTORIZADA':'授權調查',
        'TITUTNOAUTORIZADA':'取消調查授權',
        'TITUTAUTORIZAR':'授權調查',
        'TITUTCORREGIR':'正確的調查',

      },
      'TABLACAMPOS':{
        'NAME':'調查名稱',
        'FECHAI':'開始日期',
        'FECHAF':'目標日期',
        'AVANCE':'預先',
        'ESTADO': '狀態',
        'ACCION': '行為',
      },
      'COLABORADORES':{
        'CARGACOLAB':'上傳認證合作者'
      },
      'ADMIN-PREG':{
        'TITULO-ABIE':'公開問題',
        'PREGUN':'問題',
        'PREGUNSUB':'題',
        'DESCRIP-PREGUN':'點擊此處顯示問題',
        'TITULO-UNAOPC':'一選題',
        'TITULO-MULOPC':'多項選擇題',
        'OPC':'選件',
        'OPCSUB':'選項',
        'NO-ADICI':'該調查沒有其他問題',
      },
      'STEP_COLAB':{
        'STEP_1':{
          'TITULO_STEP_ELEGIR_COLAB':'合作者的選擇類型',
          'INST_1':'選擇以下選項之一',
          'NUEVA_BASE_COLA':'上載新的貢獻者庫',
          'BASE_COLAB_EXIS':'使用主要貢獻者庫',
          'BTN_SIGUENTE':'下一個',

        },
        'STEP_2':{
          'TITULO_STEP_SUBIR_COLAB':'貢獻者的選擇',
          'MAT_TITLE_DEMO_SELE':'選定的受眾特徵',
          'ALERT_NOT_DEMO_SELE':'您尚未選擇過濾器',
          'ALERT_NOT_SELE_COLAB':'未添加合作者',
          'AGREGAR_FILTRO':'添加過濾器',
          'TH_NOMBRE':'貢獻者姓名',
          'TH_ACCION':'動作',
          'INTS_SEL_1_O_MAS_COLAB':'*注意：選擇一個或多個合作者',
          'SIN_RESULTADOS':'當前的過濾器選擇未返回任何結果，請嘗試更改過濾器，然後重試',
          'BTN_REGRESAR':'返回',
          'BTN_AGRE_COLAB':'添加合作者',
          'BTN_GUAR_COLAB':'保存合作者',
          'BTN_BORR_COLAB':'刪除合作者',
          'BTN_ACEPTAR':'接受',
          'BTN_BUSCAR':'搜索',
          'TITULO_MODAL_DEMOGRA':'人口統計清單',
          'MAT_TITLE_EXPA_RESULT':'貢獻者搜索結果：',
          'MAT_TITLE_EXPA_AGREG':'總體合作者：',
          'MAT_TITLE_EXPA_DESCRIP':'見合作者',
          'MODALES':{
            'MODAL_CARGAN_FILTROS':'加載過濾器',
            'MODAL_BUSCA_COLAB':'搜索過濾的協作者',
            'MODAL_AGRE_COLAB':'添加合作者',
            'MODAL_DELET_COLAB':'刪除協作者信息',
            'MODAL_SUCCES_AGRE_COLAB':'協作者已成功添加',
            'MODAL_GUAR_COLAB':'節省合作者',
            'MODAL_CONFIR_BORRAR_COLAB':'您確定要刪除貢獻者嗎？',
            'MODAL_CONFIR_BORRAR_COLABRES':'您確定要刪除協作者嗎？',
            'MODAL_CONFIR_GUAR_COLAB_BACK':'您確定要保存添加的協作者嗎？',
            'MODAL_SUCCES_GUAR_COLAB':'合作夥伴已正確保存',
            'MODAL_SUCCES_BORRA_COLAB':'貢獻者已正確刪除',
            'MODAL_SUCCES_BORRA_COLABRES':'貢獻者已成功刪除',
            'MODAL_WARNN_NO_SELECT_COLAB':'您尚未選擇任何協作者',
            'BTN_SI':'是的',
            'BTN_NO':'不要',
            'BTN_OK':'好的',
          },
          'FORMULARIO':{
            'fullName': '全名',
            'ownKey': '員工編號',
            'age': '出生年份',
            'surveyKey': '調查訪問密鑰',
            'email': '電子郵件',
            'bossName': '直接老闆姓名',
            'bossKey': '直接老闆號碼',
            'country': '國家',
            'location': '位置',
            'geo_1': '地理等級1',
            'geo_2': '地理等級2',
            'geo_3': '地理級別3',
            'geo_4': '地理等級4',
            'geo_5': '地理等級5',
            'geo_6': '地理等級6',
            'geo_7': '地理等級7',
            'geo_8': '地理級別8',
            'geo_9': '地理等級9',
            'geo_10': '地理級別10',
            'structure_1': '結構一級',
            'structure_2': '結構等級2',
            'structure_3': '結構等級3',
            'structure_4': '結構等級4',
            'structure_5': '結構等級5',
            'structure_6': '結構等級6',
            'structure_7': '結構等級7',
            'structure_8': '結構等級8',
            'structure_9': '結構層9',
            'structure_10': '結構層10',
            'area': '區',
            'bUnit': '業務部門',
            'enterDate': '進入公司的日期',
            'antiquity': '古代',
            'antiquityUS': '上古我們',
            'generation': '代',
            'generationUS': '一代我們',
            'ageUS': '年齡',
            'charge': '在公司中的職位或職能',
            'homologado': '充電或功能批准',
            'homologadoUS': '收費或功能批准了我們',
            'gender': '性別',
            'genderType': '性別類型',
            'typeofwork': '補償類型',
            'workCondition': '工作條件',
            'academico': '學位',
            'contratacion': '合同類型',
            'situacionUS': '我們的工作情況',
            'personal': '員工類型',
            'jornada': '工作時間表類型',
            'rotacion': '確實旋轉',
            'phone': '合作者的電話',
            'extension': '合作者的直接擴展',
            'cellphone': '合作者的手機',
            'native': '母語',
            'answer': '回答',
            'other_1': '其他1',
            'other_2': '其他2',
            'other_3': '其他3',
            'other_4': '其他4',
            'other_5': '其他5',
            'other_6': '其他6',
            'other_7': '其他7',
            'other_8': '其他8',
            'other_9': '其他9',
            'other_10': '其他10',
          },
        },
    }

    }
  }
};
